import React from 'react';

interface DeploymentEnvironmentBannerProps {
    environment?: string;
    isVisible: boolean;
}

const supportedEnvironmentClassNames: Record<string, string> = {
    blue: 'blue',
    green: 'green',
};

export const DeploymentEnvironmentBanner = ({ environment, isVisible }: DeploymentEnvironmentBannerProps) => {
    const normalizedEnvironment = environment?.trim().toLowerCase();
    const environmentClassName = normalizedEnvironment ? supportedEnvironmentClassNames[normalizedEnvironment] : undefined;

    if (!isVisible || !normalizedEnvironment || !environmentClassName) {
        return null;
    }

    return (
        <div className={`deployment-environment-banner deployment-environment-banner--${environmentClassName}`}>
            <span className="deployment-environment-banner__text">{normalizedEnvironment.toUpperCase()} ENVIRONMENT</span>
        </div>
    );
};
